import { render, staticRenderFns } from "./NewMessageNotificationModal.vue?vue&type=template&id=9bf1e846"
import script from "./NewMessageNotificationModal.vue?vue&type=script&lang=js"
export * from "./NewMessageNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports